// "Seen before": jobs in the recent list whose sample has this SHA-256 (DESIGN_SPEC §11.2 picked state).
//   useSeenBefore(sha) → { job, count } | null      job = the newest match; count = matches in the list
//   matchSamples(jobs, sha)                          the pure lookup (case-insensitive)
import { useMemo } from "react";
import { useJobs } from "@/hooks";
import type { Job } from "@/types";

export const SEEN_LIMIT = 100;

export function matchSamples(jobs: readonly Job[], sha: string): Job[] {
  const want = sha.toLowerCase();
  return jobs.filter((j) => j.sample_sha?.toLowerCase() === want);
}

export function useSeenBefore(sha: string | null | undefined): { job: Job; count: number } | null {
  const { data } = useJobs(SEEN_LIMIT);
  return useMemo(() => {
    if (!sha || !data) return null;
    const hits = matchSamples(data, sha);
    return hits.length ? { job: hits[0], count: hits.length } : null;
  }, [data, sha]);
}
